export function wrapForNoInteraction(html: string | undefined) {
    return html || '';
}

export function unwrapHTML(html: string | undefined): string {
    return html || '';
}
